export default __webpack_public_path__ + "bd4c565da37f749475f02c8a9c686ccf.png";